/**
 * v-b-popover directive - replaces bootstrap-vue's, with the same markup, timings and behaviour, but only
 * for what the app uses (pinned by __tests__/bootstrap/vBPopover.test.js):
 *
 *   v-b-popover.hover="text"       shown on hover
 *   v-b-popover.hover.html="html"  the text is rendered as HTML
 *
 * The text is the directive value. There is no header: bootstrap-vue takes it from the `title` attribute,
 * which no popover in the app has. Placement is always "right" (flips when there is no room).
 * It is a tooltip with other markup, so everything else is shared with vBTooltip.js.
 * Reference: node_modules/bootstrap-vue/src/directives/popover and .../components/popover/helpers.
 */
import { createTipDirective } from "@/components/bootstrap/vBTooltip"

const POPOVER = {
  name: 'popover',
  innerClass: 'popover-body',
  placement: 'right',
  config(binding) {
    const modifiers = binding.modifiers || {}
    const content = binding.value
    return {
      title: typeof content === 'string' || typeof content === 'number' ? content : undefined,
      html: !!modifiers.html,
      interactive: true,
      triggers: ['hover'],
    }
  }
}

export const vBPopover = createTipDirective(POPOVER)

export default vBPopover
